export type AttributeValueType =
  | 'string'
  | 'integer'
  | 'number'
  | 'boolean'

export interface AttributeType {
  path: string
  type: AttributeValueType
}

export interface ParameterType {
  name: string
  type: 'string' | 'integer' | 'boolean'
  required: boolean
  pattern?: string
  description?: string
  in?: string
  default?: any
}

export interface EndpointType {
  path: string
  response_example?: any
  nodes_by_resource_type: {
    collection: string[]
    single: string[]
  }
  attributes_by_node: Record<string, AttributeType[]>
  parameters?: ParameterType[]
}

export function attributesForNode (endpoint: EndpointType | null, node: string): AttributeType[] {
  return endpoint?.attributes_by_node?.[node] ?? []
}

export function removePlaceholderOption (select: HTMLSelectElement): void {
  if (select.options[0]?.value === '' && select.value !== '') {
    select.options.remove(0)
  }
}

export function loadEndpointsMetadata (select: HTMLSelectElement): Record<string, EndpointType> {
  const data: Record<string, EndpointType> = {}

  Array.from(select.options).forEach(option => {
    if (option.value === '') return

    const { nodesByResourceType, responseExample, attributesByNode, parameters, path } = option.dataset
    if ((nodesByResourceType == null) || (nodesByResourceType === '')) {
      console.warn('No nodesByResourceType found for option', option.value)
      return
    }

    try {
      data[option.value] = {
        path: path ?? '',
        nodes_by_resource_type: JSON.parse(nodesByResourceType),
        attributes_by_node: attributesByNode != null ? JSON.parse(attributesByNode) : {},
        response_example: ((responseExample != null) && (responseExample !== '')) ? JSON.parse(responseExample) : undefined,
        parameters: ((parameters != null) && (parameters !== '')) ? JSON.parse(parameters) : []
      }
    } catch (e) {
      console.error('Failed to parse endpoint metadata for option', option.value, e)
    }
  })

  return data
}
